import RootState from '../../types';

export const selectActiveLevel = (state: RootState) =>
  state.game.levelCompleted === state.game.totalNumberOfLevels ? 1 : state.game.levelCompleted + 1;
export const selectTotalNumberOfLevels = (state: RootState) => state.game.totalNumberOfLevels;
export const selectApiCallInProgress = (state: RootState) => state.game.apiCallInProgress;
